// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable init-declarations */
import * as cookies from "@kiwicom/cookies"

import initKeyBindings from "../../../app/scripts/tools/initKeyBindings"
import { initWindowBindings } from "../../../app/scripts/tools/windowBindings"

export default function subscribeStore(store) {
  let currency
  store.subscribe(() => {
    const previousCurrency = currency
    currency = store.getState().options.get("currency")
    if (previousCurrency !== currency) {
      cookies.save("preferred_currency", currency)
    }
  })

  initKeyBindings(store)
  initWindowBindings(store)
}
